module.exports = __webpack_public_path__ + "img/mrsmith-mobile.9685dc62.jpg";